<template>
  <div class="welfare">
    <div
      class="label"
      ref="label"
      :style="{ transform: `translateY(${translateY}px)` }"
    >
      <div class="label-name">WELFARE</div>
    </div>
    <div class="container">
      <div class="main-img"><img :src="images.welfareBanner" /></div>
      <div class="welfare-blocks">
        <ContentBlock
          hasUnderLine="true"
          labelName="Welfare"
          labelNo="01"
          enTitle="Workshop"
          :contentImg="images.welfareWorkshop"
          contentText="新芽同事們臥虎藏龍，透過工作坊共同分享、討論技術或行銷新知。也可以提出有興趣的內容，邀請外部講師來上課。"
        >
        </ContentBlock>
        <ContentBlock
          hasUnderLine="true"
          labelName="Welfare"
          labelNo="02"
          enTitle="Sprouters' Outing"
          :contentImg="images.welfareOuting"
          contentText="年度國內旅行，快樂玩耍促進團隊情誼，也回顧該年大事紀，並訂定下一年目標。"
        >
        </ContentBlock>
        <ContentBlock
          hasUnderLine="true"
          labelName="Welfare"
          labelNo="03"
          enTitle="Movie Night"
          :contentImg="images.welfareMovie"
          contentText="每季一次的電影之夜，一起觀賞當季最受矚目的電影。"
        >
        </ContentBlock>
        <ContentBlock
          hasUnderLine="true"
          labelName="Welfare"
          labelNo="04"
          enTitle="Sprouters' Day"
          :contentImg="images.sproutersDay"
          contentText="每月一次大家一起討論公司大小事，所有夥伴都可以參與討論、共同打造新芽組織文化。"
        >
        </ContentBlock>
      </div>
    </div>
  </div>
</template>

<script>
import ContentBlock from "../source/ContentBlock.vue";

import welfareBanner from "../../static/images/sectionWork/2025/welfare-01.jpg";
import welfareWorkshop from "../../static/images/sectionWork/welfare-workshop.jpg";
import welfareOuting from "../../static/images/sectionWork/2025/welfare-outing.jpg";
import welfareMovie from "../../static/images/sectionWork/welfare-movie.jpg";
import sproutersDay from "../../static/images/sectionWork/welfare-sprouters-day.jpg";

export default {
  name: "Welfare",
  components: {
    ContentBlock,
  },
  data: function () {
    return {
      images: {
        welfareBanner: welfareBanner,
        welfareWorkshop: welfareWorkshop,
        welfareOuting: welfareOuting,
        welfareMovie: welfareMovie,
        sproutersDay: sproutersDay,
      },
      parallaxConfig: {
        execute: true,
        start: -50,
        end: 50,
        translateTop: 40,
        translateBottom: -40,
      },
      label: {
        el: null,
        top: null,
        bottom: null,
      },
      scrollY: 0,
      translateY: 0,
    };
  },
  methods: {
    getScrollY: function () {
      this.scrollY = window.scrollY;
    },
    getLabelValue: function () {
      if (this.label.el) {
        this.label.top = this.label.el.offsetTop;
        this.label.bottom =
          this.label.el.offsetTop + this.label.el.offsetHeight;
        return true;
      }
      return false;
    },
    map: function (
      value,
      currentLower,
      currentUpper,
      targetLower,
      targetUpper
    ) {
      return (
        ((value - currentLower) * (targetUpper - targetLower)) /
          (currentUpper - currentLower) +
        targetLower
      );
    },
    parallax: function () {
      this.getScrollY();
      const hasLabelValue = this.getLabelValue();

      if (hasLabelValue && this.parallaxConfig.execute) {
        const upperBound =
          this.label.bottom - window.innerHeight - this.parallaxConfig.end;
        const lowerBound = this.label.top + this.parallaxConfig.start;

        if (this.scrollY < upperBound) {
          this.translateY = this.parallaxConfig.translateTop;
        } else if (this.scrollY > upperBound && this.scrollY < lowerBound) {
          this.translateY = this.map(
            scrollY - this.parallaxConfig.start,
            upperBound,
            lowerBound,
            this.parallaxConfig.translateTop,
            this.parallaxConfig.translateBottom
          );
        } else {
          this.translateY = this.parallaxConfig.translateBottom;
        }
      } else {
        this.translateY = 0;
      }
    },
    handleResize: function () {
      const winWidth = window.innerWidth;
      if (winWidth <= 768) {
        this.parallaxConfig.execute = false;
      } else {
        this.parallaxConfig.execute = true;
      }
    },
  },
  mounted: function () {
    this.label.el = this.$refs.label;
    this.label.top = this.label.el.offsetTop;
    this.label.bottom = this.label.el.offsetTop + this.label.el.offsetHeight;
    this.handleResize();
  },
  created: function () {
    window.addEventListener("scroll", this.parallax);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.parallax);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped
       lang="scss">
@import "../../static/styles/palette.scss";

.welfare {
  & .label {
    position: relative;
    float: right;
    top: 80px;
    width: calc((100% - 925px) / 2 + 200px);
    min-width: 430px;
    height: 180px;
    border: 6px solid $blue;
    border-right: 0;
    z-index: 10;

    & .label-name {
      margin: 40px 0 0 40px;
      font-family: "Fugaz One";
      font-size: 44px;
      letter-spacing: 5.4px;
      color: $blue;
    }
  }

  & .container {
    width: 925px;
    margin: 0 auto;
    z-index: 5;

    & .main-img {
      position: relative;
      width: 100%;
      margin: 0 auto;

      & img {
        width: 100%;
      }
    }

    & .welfare-blocks {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;

      & .content-block {
        width: calc(50% - 30px);
      }

      & .content-block:nth-child(2n + 1) {
        margin-left: 0;
      }
      & .content-block:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}

@media all and (max-width: 1200px) {
  .welfare {
    & .label {
      width: 350px;
      min-width: auto;
      height: 150px;
      top: 60px;

      & .label-name {
        margin: 30px 0 0 40px;
        font-size: 35px;
      }
    }

    .container {
      width: 80%;
    }
  }
}

@media all and (max-width: 960px) {
  .welfare {
    & .label {
      width: 300px;
      height: 130px;

      & .label-name {
        font-size: 30px;
      }
    }

    .container {
      width: calc(100% - 120px);

      & .welfare-blocks {
        & .content-block {
          margin: 30px 0 !important;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .welfare {
    & .label {
      border: none;
      top: 0;
      float: none;
      margin: 0 0 20px;
      height: auto;
    }

    .container {
      width: calc(100% - 70px);
    }
  }
}

@media all and (max-width: 480px) {
  .welfare {
    & .label {
      & .label-name {
        margin: 30px 0 0 30px !important;
        font-size: 26px;
      }
    }

    & .container {
      width: calc(100% - 60px);
    }
  }
}

@media all and (max-width: 320px) {
  .welfare {
    & .label {
      & .label-name {
        margin: 30px 0 0 20px !important;
      }
    }

    & .container {
      width: calc(100% - 40px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// Welfare.vue?3866c872